import React, { useState } from 'react'
import { TabContent, TabPane } from 'reactstrap'
import BodyTable from '../Table'
import useEducatorsNeedingObservation from '../../Model/educatorsNeedingObservation'
import useEducatorsObservations from '../../Model/educatorsObservations'
import useTranslation from '../../../../../i18n/useTranslation'

const FrecuencyObservations = () => {
    const { translate } = useTranslation()
    const tabSections = [
        {
            key: 'comming',
            // label: 'Comming observations'
            label: translate('dashboard.educatorObservations.upcoming')
        },
        // {
        //     key: COMMING_STATUS,
        //     label: 'Plans Ending Soon'
        // },
        {
            key: 'scheduled',
            // label: 'Completed observations'
            label: translate('dashboard.educatorObservations.overview')
        },
    ]
    //eslint-disable-next-line
    const [statusFilters, setStatusFilters] = useState(tabSections[0].key)
    //eslint-disable-next-line
    const { data: educatorsCurrent, loading: loadEducatorsCurrent, error: educatorsCurrentError, refetch: refetchEducatorsCurrent } = useEducatorsNeedingObservation()
    //eslint-disable-next-line
    const { data: educatorsScheduled, loading: loadEducatorsScheduled, error: educatorsScheduledError, refetch: refetchEducatorsScheduled } = useEducatorsObservations()
    const RenderFilter = () => {
        return (
            <>
                {
                    tabSections.map(
                        ({ key, label }) => {
                            return (<span className={`h45 nav-title ${statusFilters === key ? 'active' : ''}`} onClick={() => { setStatusFilters(key) }}>{label}</span>)
                        }
                    )
                }
            </>
        )
    }

    return (
        <>
            <TabContent className='w-100 h-100' activeTab={statusFilters}>
                <TabPane className='w-100 h-100 no-animation' tabId={'comming'}>
                    <BodyTable
                        filterSection={<RenderFilter activeTab={statusFilters} onTabChange={setStatusFilters} />}
                        tableToShow='current'
                        loading={loadEducatorsCurrent}
                        educators={educatorsCurrent}
                        refetch={refetchEducatorsCurrent}
                    />

                </TabPane>

                <TabPane className='w-100 h-100 no-animation' tabId={'scheduled'}>
                    <BodyTable
                        filterSection={<RenderFilter activeTab={statusFilters} onTabChange={setStatusFilters} />}
                        tableToShow='scheduled'
                        loading={loadEducatorsScheduled}
                        educators={educatorsScheduled}
                        refetch={refetchEducatorsScheduled}
                    />
                </TabPane>
            </TabContent>
            {/* <PlanModal refetch={() => { }} /> */}
            {/* <DismissPlanModal /> */}
            {/* <PostponeRemiderModal /> */}
            {/* <NewPlan refetch={() => { refetchDashboardPlansToSend() }} educators={[]} /> */}
            {/* <AlertNotification loading={loadQueryToSend || loadQueryEndSoon || loadQueryToComplete} show={false} onClick={() => { refetch() }} /> */}
        </>
    )
}
export default FrecuencyObservations